/* jshint esversion: 6 */
import { useNavigate } from 'react-router-dom';

const Success = () => {

    const navigat = useNavigate();

    function handlePaymentSuccess() {
        const pages = sessionStorage.getItem("pages");
        if (pages === "wallet") {
            sessionStorage.setItem("Paymentstatus", "PaymentDone");
            navigat("/wallet");
        } else {
            sessionStorage.setItem("Paymentstatus", "PaymentFaild");
            navigat("/cardetails");
        }
    }

    window.onload = function () {
        handlePaymentSuccess();
    };

    return null;
};

export default Success;

export const Cancel = () => {
    const navigat = useNavigate();
    function handlePaymentSuccess() {
        const pages = sessionStorage.getItem("pages");
        navigat(`/${pages}`);
        sessionStorage.setItem("Paymentstatus", "PaymentFaild");
    }

    window.onload = function () {
        handlePaymentSuccess();
    };

    return null;

};